var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sign-out-alt_1_",
    "data-name": "sign-out-alt (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.674,
    height: 19.075,
    viewBox: "0 0 18.674 19.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15554",
    "data-name": "Path 15554",
    d: "M19.449,9.216,15.515,5.282,14.392,6.409,17.81,9.827H6.617v1.59H17.81l-3.418,3.418,1.124,1.124,3.934-3.934a1.987,1.987,0,0,0,0-2.81Z",
    transform: "translate(-1.358 -1.084)",
    fill: "#1d2432"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15555",
    "data-name": "Path 15555",
    d: "M8.326,16.69a.8.8,0,0,1-.795.795H2.384a.8.8,0,0,1-.795-.795V2.384a.8.8,0,0,1,.795-.795H7.531a.8.8,0,0,1,.795.795V6.623h1.59V2.384A2.384,2.384,0,0,0,7.531,0H2.384A2.384,2.384,0,0,0,0,2.384V16.69a2.384,2.384,0,0,0,2.384,2.384H7.531A2.384,2.384,0,0,0,9.916,16.69V12.452H8.326Z",
    fill: "#1d2432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/signOut.462e6dd60b08790bd556104855adcb22.svg";
export { ForwardRef as ReactComponent };